/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import LiveTickerBar from "../../components/live-ticker-bar/liveTickerBar";
import "./watchlist.scss";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { InputSwitch } from "primereact/inputswitch";
import { Toast } from "primereact/toast";
import { useSelector, useDispatch } from "react-redux";
import {
  setActiveTitle as setActiveTitleRedux,
  setActiveTitleId as setActiveTitleIdRedux
} from "../../stores/watchlist";
import ListBar from "./components/listBar/listbarWatchlist";
import ParallelButtonSelection from "../../components/selections/periodSelection/parallelButtonSelection";
import News from "../news/news";
import { DashboardServiceApi, QueryServiceApi } from "../../services/watchlist/api";
import { Configuration } from "../../services/watchlist/configuration";
import lodash from 'lodash';
import { ConfirmDialog } from "primereact/confirmdialog";
import WatchlistTable from "./components/table";
import { APIControl } from "../../helpers/APIControl";
import { useTranslation } from "react-i18next";
import ErrorView from '../../components/alert/error-view';
import { setJustAddedSymbol, setPendingRefresh } from "../../stores/watchlistTableSearchItemSlice";

const WL_PERF_ENABLED = typeof window !== 'undefined' && window.location.search.includes('wlPerf=1');

const markWatchlistPerf = (name) => {
  if (!WL_PERF_ENABLED || typeof performance === 'undefined' || !performance.mark) return;
  performance.mark(name);
};

export default function Watchlist() {
  const streamingRef = useRef(null);
  const unsubscribeLiveStreaming = useRef(null);
  const isFetchingRef = useRef(false);
  const lastFetchedListId = useRef(null);

  const token = localStorage.getItem('token');
  const toast = useRef(null);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const watchlistApi = useMemo(() => new DashboardServiceApi(
    new Configuration({ basePath: process.env.REACT_APP_WATCHLIST_API_BASE_PATH }),
    undefined,
    APIControl(process.env.REACT_APP_WATCHLIST_API_BASE_PATH)
  ), []);

  const queryServiceApi = useMemo(() => new QueryServiceApi(
    new Configuration({ basePath: process.env.REACT_APP_WATCHLIST_API_BASE_PATH }),
    undefined,
    APIControl(process.env.REACT_APP_WATCHLIST_API_BASE_PATH)
  ), []);

  const activeTitle = useSelector((state) => state.watchlist.activeTitle);
  const activeTitleId = useSelector((state) => state.watchlist.activeTitleId);
  const updatedWatchlist = useSelector((state) => state.watchlistTableSearchItem.updatedList);
  const justAddedSymbol = useSelector((state) => state.watchlistTableSearchItem.justAddedSymbol);
  const pendingRefresh = useSelector((state) => state.watchlistTableSearchItem.pendingRefresh);

  const [ratioTitles, setRatioTitles] = useState([]);
  const [checked, setchecked] = useState(true);
  const [fetchData, setFetchData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [staticLiveData, setStaticLiveData] = useState([]);
  const [columnsData, setColumnsData] = useState([]);
  const [symbolListData, setSymbolListData] = useState([]);
  const [newsEntityIds, setNewsEntityIds] = useState([]);
  const [watchlistModels, setWatchlistModels] = useState();
  const [isLoadingTable, setIsLoadingTable] = useState(true);
  const [isCurrentListEmpty, setIsCurrentListEmpty] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [selectedListBarItemId, setSelectedListBarItemId] = useState("");
  const [selectedListBarItemName, setSelectedListBarItemName] = useState();
  const [selectedRemoveItemData, setSelectedRemoveItemData] = useState([]);
  const [removedEntityId, setRemovedEntityId] = useState();
  const [updateListBar, setUpdateListBar] = useState(false);
  const [serviceError, setServiceError] = useState(false);
  const [inflationNoteShow, setInflationNoteShow] = useState(false);
  const [wereItemsFilteredForInflation, setWereItemsFilteredForInflation] = useState(false);

  const memoColumns = useMemo(() => columnsData, [columnsData]);

  // ─── Effects ────────────────────────────────────────────────────────────────

  useEffect(() => {
    setIsLoadingTable(true);
    getHeadersData();
  }, [language]);

  useEffect(() => {
    if (ratioTitles.length > 0) {
      dispatch(setActiveTitleRedux(ratioTitles[0]));
      dispatch(setActiveTitleIdRedux(ratioTitles[0].id));
    }
  }, [ratioTitles, dispatch]);

  useEffect(() => {
    if (selectedListBarItemId) {
      getWatchlistsModelsService();
    }
  }, [selectedListBarItemId]);

  useEffect(() => {
    if (watchlistModels && activeTitle) {
      generateColumns();
    }
  }, [watchlistModels, activeTitle]);

  // Single fetch trigger: runs when columns or list changes.
  // lastFetchedListId prevents re-fetch on tab (column) change for the same list.
  useEffect(() => {
    if (columnsData.length > 0 && selectedListBarItemId) {
      getFetchData();
    }
  }, [columnsData, selectedListBarItemId]);

  useEffect(() => {
    if (!activeTitle || fetchData.length === 0) return;

    const transformStartTime = performance.now();

    if (activeTitle.id === 1) {
      setIsLoadingTable(false);
      setStaticLiveData(fetchData.map(item => ({
        Code: item.code,
        entityId: item.entityId,
        indicators: item.indicators || [],
        name: item.name,
      })));
      setTableData([]);
    } else {
      setStaticLiveData([]);
      const validCategory = `${activeTitle.binding}Cells`;
      const columnBindings = new Set(columnsData.map(col => col.binding));
      const processedData = fetchData.map(item => {
        const cells = item[validCategory] || [];
        const rowData = {
          entityId: item.entityId,
          code: item.code,
          indicators: item.indicators || [],
          name: item.name,
        };
        cells.forEach(cell => {
          const binding = cell.dataId.toString();
          if (columnBindings.has(binding)) {
            rowData[binding] = normaliseNumber(cell.value);
          }
        });
        return rowData;
      });
      setTableData(processedData);
      setIsLoadingTable(false);
    }

    const transformEndTime = performance.now();
    console.log(`[watchlist log] Veri Transformasyonu (fetchData -> tableData) tamamlandı: ${(transformEndTime - transformStartTime).toFixed(2)} ms`);
  }, [fetchData, activeTitle, columnsData]);

  useEffect(() => {
    const handleReload = () => {
      dispatch(setJustAddedSymbol(false));
      if (pendingRefresh && !isFetchingRef.current) {
        getFetchData(true);
        dispatch(setPendingRefresh(false));
      }
    };
    window.addEventListener("reloadData", handleReload);
    return () => window.removeEventListener("reloadData", handleReload);
  }, [pendingRefresh, dispatch]);

  useEffect(() => {
    if (!updatedWatchlist) return;

    setUpdateListBar(prev => !prev);

    if (updatedWatchlist.targetEntityId) {
      const targetSymbol = fetchData.find(item => item.entityId === updatedWatchlist.targetEntityId);
      if (targetSymbol) {
        setTableData(prevData =>
          prevData.map(item =>
            item.entityId === updatedWatchlist.targetEntityId
              ? { ...item, indicators: targetSymbol.indicators || [] }
              : item
          )
        );
        if (activeTitle?.id === 1) {
          setStaticLiveData(prev =>
            prev.map(item =>
              item.entityId === updatedWatchlist.targetEntityId
                ? { ...item, indicators: targetSymbol.indicators || [] }
                : item
            )
          );
        }
      }
    } else if (
      (!updatedWatchlist.noReload && !updatedWatchlist.preventRefresh && !justAddedSymbol) ||
      updatedWatchlist.requireFullRefresh
    ) {
      getFetchData(true);
    } else if (justAddedSymbol && updatedWatchlist.updatedList) {
      const newSymbol = updatedWatchlist.updatedList.find(s =>
        !tableData.some(t => t.entityId === s.entityId)
      );
      if (newSymbol) {
        setTableData(prev => [...prev, newSymbol]);
        if (activeTitle?.id === 1) {
          setStaticLiveData(prev => [...prev, {
            Code: newSymbol.code,
            entityId: newSymbol.entityId,
            indicators: newSymbol.indicators || [],
            name: newSymbol.name,
          }]);
        }
      }
    }
  }, [updatedWatchlist]);

  useEffect(() => {
    if (!activeTitleId || activeTitleId !== 4) {
      setInflationNoteShow(false);
      return;
    }
    setInflationNoteShow(wereItemsFilteredForInflation);
  }, [wereItemsFilteredForInflation, activeTitleId]);

  // ─── Helpers ─────────────────────────────────────────────────────────────────

  const normaliseNumber = (v) => {
    if (v === undefined || v === null || v === '' || v === 'NaN') return null;
    const n = Number(v);
    return Number.isNaN(n) ? null : n;
  };

  // ─── List interaction ────────────────────────────────────────────────────────

  const selectedListBarItem = (id, name, count) => {
    try {
      if (!id) return;

      setIsLoadingTable(true);
      setSelectedListBarItemId(id);
      setSelectedListBarItemName(name);
      setTableData([]);
      setIsCurrentListEmpty(count === 0);

      if (count === 0) {
        setIsLoadingTable(false);
      }

      getSymbolList(id);

      if (streamingRef.current) {
        unsubscribeLiveStreaming.current?.Dispose?.();
        streamingRef.current = null;
      }
    } catch (error) {
      console.error("selectedListBarItem error:", error);
      setIsLoadingTable(false);
    }
  };

  const restartColumns = () => {
    columnsData.forEach(item => {
      item.isVisible = item.defaultVisible;
    });
  };

  const removeSymbolReject = () => setVisibleAlert(false);

  const removeSymbolOnWatchlist = useCallback((data) => {
    const displayName = data.code || data.name || data.symbolName || '-';
    setAlertMessage(t('watchList.removeSymbolQuestion', { displayName, listName: selectedListBarItemName }));
    setVisibleAlert(true);
    setSelectedRemoveItemData(data);
  }, [selectedListBarItemName, t]);

  // ─── Tab selection ───────────────────────────────────────────────────────────

  const clickRatioButtonTitle = useCallback((title) => {
    if (title?.id === activeTitleId) return;
    markWatchlistPerf('wl:title-click:start');
    dispatch(setActiveTitleRedux(title));
    dispatch(setActiveTitleIdRedux(title.id));
    // generateColumns runs via [watchlistModels, activeTitle] effect
    // getFetchData runs via [columnsData, selectedListBarItemId] effect,
    // but is skipped by lastFetchedListId guard (same list → cache hit)
  }, [activeTitleId, dispatch]);

  const generateColumns = () => {
    const titleColumns = watchlistModels[activeTitle.binding] || [];
    const formattedColumns = titleColumns.map((item, index) => {
      const code = item.code || item.id.toString();
      return {
        binding: activeTitle.id === 1 ? code : item.id.toString(),
        header: item.name,
        width: '*',
        align: 'right',
        dataType: 'String',
        defaultVisible: item.default,
        isVisible: item.enable,
        IsRealtimeContent: activeTitle.id === 1,
        CanbeHide: true,
        VisibleIndex: index + 1,
        order: item.order,
        info: item.info,
      };
    });
    setColumnsData(formattedColumns);
  };


  // ─── API calls ───────────────────────────────────────────────────────────────

  const getHeadersData = () => {
    watchlistApi.watchlistHeadersGet(token, language)
      .then((res) => {
        const mappedRatioTitles = res.data.items.map((item, index) => ({
          id: index + 1,
          name: item.name,
          binding: item.binding,
        }));
        setRatioTitles(mappedRatioTitles);
      })
      .catch((err) => {
        setServiceError(true);
        toast.current.show({
          severity: 'error',
          summary: t('services.error.headers'),
          detail: err.message || JSON.stringify(err),
          life: 3000,
        });
      });
  };

  const getSymbolList = (listId) => {
    setSymbolListData([]);
    watchlistApi.watchlistSymbolListGet(token, listId, language)
      .then((res) => {
        if (res.data.error) {
          toast.current.show({
            severity: 'error',
            summary: t('services.error.symbolList'),
            detail: res.data.error,
            life: 3000,
          });
          setIsLoadingTable(false);
          return;
        }
        const symbols = res.data.symbols || [];
        setSymbolListData(symbols);
        setNewsEntityIds(lodash.map(symbols, 'code'));
        if (symbols.length === 0) {
          setTableData([]);
          setFetchData([]);
          setIsLoadingTable(false);
        }
      })
      .catch((err) => {
        setServiceError(true);
        toast.current.show({
          severity: 'error',
          summary: t('services.error.symbolList'),
          detail: err.message || JSON.stringify(err),
          life: 3000,
        });
        setIsLoadingTable(false);
      });
  };

  const getWatchlistsModelsService = () => {
    return new Promise((resolve, reject) => {
      watchlistApi.watchlistModelsGet(token, selectedListBarItemId, language)
        .then((res) => {
          if (res.data.error) {
            toast.current.show({
              severity: 'error',
              summary: t('services.error.watchlistModels'),
              detail: res.data.error,
              life: 3000,
            });
            return reject(res.data.error);
          }

          const processedData = {};
          Object.keys(res.data).forEach(key => {
            processedData[key] = Array.isArray(res.data[key])
              ? res.data[key].filter(col => col.code !== 'indicators' && col.binding !== 'indicators')
              : res.data[key];
          });

          setWatchlistModels(processedData);
          resolve();
        })
        .catch((err) => {
          setServiceError(true);
          reject(err);
        });
    });
  };

  const getFetchData = (force = false) => {
    if (!force && lastFetchedListId.current === selectedListBarItemId) {
      return; // Same list, same tab — no need to re-fetch
    }
    if (isFetchingRef.current) return;

    lastFetchedListId.current = selectedListBarItemId;
    isFetchingRef.current = true;
    setIsLoadingTable(true);

    const apiStartTime = performance.now();

    queryServiceApi.queryFetchDataGet(token, selectedListBarItemId)
      .then((res) => {
        const apiEndTime = performance.now();
        console.log(`[watchlist log] 🌍 API Yanıt Süresi (queryFetchDataGet): ${(apiEndTime - apiStartTime).toFixed(2)} ms`);

        if (res.data.error) {
          toast.current.show({
            severity: 'error',
            summary: t('services.error.symbolsData'),
            detail: res.data.error,
            life: 3000,
          });
          setIsLoadingTable(false);
          return;
        }

        const items = res.data.items || [];
        if (items.length > 0) {
          const processedItems = items.map(item => ({
            ...item,
            indicators: item.indicators || [],
          }));
          setFetchData(processedItems);
          // Loading is turned off in the [fetchData, activeTitle, columnsData] effect
          // after the data is processed into tableData/staticLiveData.
        } else {
          setFetchData([]);
          setIsLoadingTable(false);
        }
      })
      .catch((err) => {
        setServiceError(true);
        const errorMessage = err?.response?.data?.error || err?.error || err?.message || JSON.stringify(err);
        toast.current.show({
          severity: 'error',
          summary: t('services.error.symbolsData'),
          detail: errorMessage,
          life: 3000,
        });
        setIsLoadingTable(false);
      })
      .finally(() => {
        isFetchingRef.current = false;
      });
  };

  const removeSymbol = () => {
    try {
      const entityId = selectedRemoveItemData.entityId;
      watchlistApi.watchlistRemoveSymbolGet(token, selectedListBarItemId, entityId)
        .then((res) => {
          if (res.data.error) {
            toast.current.show({
              severity: 'error',
              summary: t('services.error.symbolRemove'),
              detail: res.data.error,
              life: 3000,
            });
            return;
          }

          toast.current.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('watchlist.symbolRemoved'),
            life: 3000,
          });

          setRemovedEntityId(entityId);
          setUpdateListBar(prev => !prev);

          const symbolIndex = symbolListData.findIndex(item => item.entityId === entityId);
          if (symbolIndex !== -1) {
            const updated = [...symbolListData];
            updated.splice(symbolIndex, 1);
            setSymbolListData(updated);
          }

          const tableIndex = tableData.findIndex(item => item['@'] === entityId);
          if (tableIndex !== -1) {
            const updated = [...tableData];
            updated.splice(tableIndex, 1);
            setTableData(updated);
          }
        })
        .catch(console.error);
      setVisibleAlert(false);
    } catch (error) {
      console.error("removeSymbol error:", error);
    }
  };

  // ─── Render ──────────────────────────────────────────────────────────────────

  return (
    <div id="watchlistScreen">
      <Toast ref={toast} position="bottom-right" />

      <ConfirmDialog
        visible={visibleAlert}
        onHide={() => setVisibleAlert(false)}
        message={alertMessage}
        header={t('warning')}
        icon="pi pi-exclamation-triangle"
        accept={removeSymbol}
        reject={removeSymbolReject}
        acceptLabel={t('yes')}
        rejectLabel={t('cancel')}
      />

      <Container>
        <Row className="m-t-5">
          <Col style={{ textAlign: "right", padding: 0 }}>
            <InputSwitch className="inputSwitch" checked={checked} onChange={(e) => setchecked(e.value)} />
          </Col>
        </Row>
      </Container>

      {checked && <LiveTickerBar />}

      <div className="m-b-25 d-flex flex-wrap">
        <ListBar selectedListBarItem={selectedListBarItem} updateListBarId={updateListBar} />
      </div>

      <Container className="p-0">
        <Row>
          <Col md="10">
            <ParallelButtonSelection titles={ratioTitles} activeTitle={activeTitleId} clickTitle={clickRatioButtonTitle} />
          </Col>
          <Col md="2" />
        </Row>
      </Container>

      {serviceError && <ErrorView />}
      {!serviceError && (
        <WatchlistTable
          staticLiveData={staticLiveData}
          symbolListData={symbolListData}
          removeSymbolOnWatchlist={removeSymbolOnWatchlist}
          columnsList={memoColumns}
          restartColumns={restartColumns}
          tableData={tableData}
          removedEntityId={removedEntityId}
          selectedListBarItem={selectedListBarItemId}
          activeCategory={activeTitle}
          isEmptyList={isCurrentListEmpty}
          onItemsFiltered={setWereItemsFilteredForInflation}
        />
      )}

      {inflationNoteShow && (
        <div className="inflation-note">
          <p>{t('standouts.inflationNote', { year: new Date().getFullYear() })}</p>
        </div>
      )}

      {newsEntityIds.length > 0 && (
        <>
          <div className="roboto-bold-20 titleGreenWhite m-t-30">{t('watchlist.myListNews')}</div>
          <News constutientEntityId={'ANY'} entityIds={newsEntityIds} showLiveTicker={false} beginOfDate={1} />
        </>
      )}
    </div>
  );
}
